module.exports = __webpack_public_path__ + "img/max-file-approve--zip.d998b4d9.svg";